/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as errors from "../../../../errors/index.js";
import * as core from "../../../../core/index.js";

export class ServiceUnavailableError extends errors.LangfuseAPIError {
  constructor(rawResponse?: core.RawResponse) {
    super({
      message: "ServiceUnavailableError",
      statusCode: 503,
      rawResponse: rawResponse,
    });
    Object.setPrototypeOf(this, ServiceUnavailableError.prototype);
  }
}
